module.exports = __webpack_public_path__ + "img/display2.c9f078b1.jpg";